import ShipmentStats from '@/app/shared/shipments/shipment-stats';
import ShipmentListTable from '@/app/shared/shipments/list/table';
import ShipmentPageHeader from '@/app/(hydrogen)/shipments/page-header';
import { metaObject } from '@/config/site.config';

export const metadata = {
  ...metaObject('Shipments'),
};

export default function LogisticsListPage() {
  return (
    <>
      <ShipmentPageHeader />
      <div className="flex flex-col gap-10">
        <ShipmentStats />
        <ShipmentListTable />
      </div>
    </>
  );
}
